module.exports = __webpack_public_path__ + "static/media/importFlybook3.2509f98b.png";